import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import differenceInYears from 'date-fns/differenceInYears';
import parseISO from 'date-fns/parseISO';
import Tooltip from 'products/nomad_insurance/components/Tooltip';
import { useDeductible } from 'products/nomad_insurance/hooks/useDeductible';
import { BoxBg, HighlightedNumber, Explanation } from './styled';

const LimitsBox = ({ isRenewal }) => {
  const { dateOfBirth } = useSelector((state) => state.app.user);
  const { activeContractDeductibleAmount, defaultDeductibleAmount } = useDeductible();

  const userAge = differenceInYears(new Date(), parseISO(dateOfBirth));
  const finalDeductibleAmount = isRenewal
    ? defaultDeductibleAmount
    : activeContractDeductibleAmount ?? defaultDeductibleAmount;

  return (
    <BoxBg>
      <div>
        <HighlightedNumber>$250,000 USD</HighlightedNumber>
        {userAge >= 65 && <div>($100,000 USD for ages 65-69)</div>}
        <Explanation>Overall limit</Explanation>
      </div>
      {finalDeductibleAmount !== 0 && (
        <div>
          <HighlightedNumber>${finalDeductibleAmount} USD</HighlightedNumber>
          <Explanation>
            Deductible
            <Tooltip>
              You cover the first ${finalDeductibleAmount} USD per policy term and the
              rest is on us!
            </Tooltip>
          </Explanation>
        </div>
      )}
    </BoxBg>
  );
};

LimitsBox.propTypes = {
  isRenewal: PropTypes.bool
};

export default LimitsBox;
